export type Invoice = {
  uniqueId: string
  status: string
  customerName: string
  customerEmail: string
  customerPhoneNumber: string
  createdDate: string
  dueDate: string
  paidDate?: string
  settledDate?: string
  expiredDate?: string
  customerReference: string
  description: string
  amount: string
  currency: string
  invoiceURL?: string
}

export enum INVOICING_ACTIONS {
  GET_INVOICES = 'INVOICING_ACTIONS.GET_INVOICES',
  IS_LOADING = 'INVOICING_ACTIONS.IS_LOADING',
}

type GetInvoices = {
  type: typeof INVOICING_ACTIONS.GET_INVOICES
  invoices: Invoice[]
}

type IsLoading = {
  type: typeof INVOICING_ACTIONS.IS_LOADING
  isLoading: boolean
}

export type ActionTypes = GetInvoices | IsLoading
